import { Component } from 'react'
import { isChunkLoadError, recoverFromChunkError, repairAssetCaches } from '../../lib/chunkLoadRecovery'

// Top-level routes (/login, /privacy, /terms, /support) sit outside Layout's
// PageRecovery. Without this boundary a failed lazy load unmounted the app and
// left an empty page (#543). A stale code file reloads once automatically;
// anything else, or a second failure, shows a visible Reload screen.
export default class AppRecoveryBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('App render failed', error, info?.componentStack)
    if (isChunkLoadError(error)) recoverFromChunkError(error)
  }

  reload = async () => {
    await repairAssetCaches(this.state.error)
    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children
    const updated = isChunkLoadError(this.state.error)
    return (
      <main role="alert" className="min-h-screen bg-charcoal-900 flex flex-col items-center justify-center gap-4 px-6 text-center">
        <h1 className="text-xl font-semibold text-cream">{updated ? 'FragranceOS was just updated' : 'Something went wrong'}</h1>
        <p className="text-sm text-cream/60">{updated ? 'Reload to open the latest version.' : 'Reload to try again.'}</p>
        <button type="button" onClick={this.reload} className="flex min-h-11 items-center justify-center rounded-xl bg-gold px-6 py-3 font-semibold text-charcoal-900">
          Reload
        </button>
      </main>
    )
  }
}
